import jsPDF from 'jspdf';

export const generateCertificate = (learnerName, courseName, dateStr) => {
  try {
    // Initialize jsPDF constructor safely to support different module bundler resolutions
    const PDFConstructor = typeof jsPDF === 'function' ? jsPDF : jsPDF.jsPDF;
    
    if (!PDFConstructor) {
      console.error("jsPDF constructor not found. Export is:", jsPDF);
      alert("Certificate generation is currently unavailable.");
      return;
    }

    const doc = new PDFConstructor({
      orientation: 'landscape',
      unit: 'pt',
      format: 'a4'
    });

    const width = doc.internal.pageSize.getWidth();
    const height = doc.internal.pageSize.getHeight();

    // Outer Border
    doc.setDrawColor(37, 99, 235); // Blue-600
    doc.setLineWidth(10);
    doc.rect(20, 20, width - 40, height - 40);

    // Inner Border
    doc.setDrawColor(226, 232, 240); // Slate-200
    doc.setLineWidth(2);
    doc.rect(30, 30, width - 60, height - 60);

    // Title
    doc.setTextColor(15, 23, 42); // Slate-900
    doc.setFontSize(40);
    doc.setFont('helvetica', 'bold');
    doc.text('CERTIFICATE OF COMPLETION', width / 2, 120, { align: 'center' });

    // Subtitle
    doc.setFontSize(16);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(100, 116, 139); // Slate-500
    doc.text('This is to certify that', width / 2, 180, { align: 'center' });

    // Learner Name - safely cast to string
    const safeName = String(learnerName || 'Learner').trim();
    doc.setFontSize(36);
    doc.setFont('helvetica', 'italic');
    doc.setTextColor(37, 99, 235); // Blue-600
    doc.text(safeName, width / 2, 240, { align: 'center' });

    // Description
    doc.setFontSize(16);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(100, 116, 139);
    doc.text('has successfully completed the training module:', width / 2, 300, { align: 'center' });

    // Course Name - safely cast to string
    const safeCourse = String(courseName || 'Security Awareness Training').trim();
    doc.setFontSize(24);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(15, 23, 42);
    doc.text(safeCourse, width / 2, 350, { align: 'center' });

    // Date & Signature lines
    doc.setFontSize(14);
    doc.setTextColor(15, 23, 42);
    
    const formattedDate = dateStr || new Date().toLocaleDateString();
    doc.text(`Date: ${formattedDate}`, width / 4, 450, { align: 'center' });
    doc.setLineWidth(1);
    doc.setDrawColor(100, 116, 139);
    doc.line((width / 4) - 50, 460, (width / 4) + 50, 460);
    
    doc.text('BIS Cyber Security Academy', (width / 4) * 3, 450, { align: 'center' });
    doc.line(((width / 4) * 3) - 70, 460, ((width / 4) * 3) + 70, 460);

    const fileName = `${safeName.replace(/\s+/g, '_')}_Certificate.pdf`;
    doc.save(fileName);
  } catch (error) {
    console.error("Error generating PDF:", error);
    alert("An error occurred while generating the certificate.");
  }
};